export default __webpack_public_path__ + "static/media/cuerpo-hombre-piel-oscura.27a5b7f9.png";